import Bar from "./bar.marko";
import Home from "./home.marko";
import Scene from "./scene.marko";
import Unit from "./unit.marko";
import People from "./people.marko";
import Person from "./person.marko";
import Words from "./words.marko";
import WordSet from "./set.marko";
import ScriptHome from "./script-home.marko";
import ScriptUnit from "./script-unit.marko";
import ScriptAudioTest from "./script-audio-test.marko";
import ScriptTapAudition from "./script-tap-audition.marko";
import ScriptReference from "./script-reference.marko";
import Switch from "./switch.marko";

static const VIEWS = { home: Home, scene: Scene, unit: Unit, people: People, person: Person, words: Words, set: WordSet, "script-home": ScriptHome, "script-unit": ScriptUnit, "script-audio-test": ScriptAudioTest, "script-reference": ScriptReference, "script-tap-audition": ScriptTapAudition };
static const CONTROLLERS = "course-profile course-audio course-table course-lookup course-progress course-lesson course-exercise course-gate course-script course-transliteration course-review-note";

<const/data=input.data/>
<if=data.view === "soon">
  <main class="ll-course ll-course-soon">
    <h1>${data.title}</h1>
    <p>${data.message}</p>
  </main>
</if>
<else>
  <main
    class=["ll-course", `ll-course--${data.view}`]
    data-ll-component=CONTROLLERS
    data-ll-gender="f"
    data-ll-course-view=data.view
    data-ll-course-lang=data.lang
  >
    <div class="ll-course-root">
      <const/showTransliteration=data.lang === "hy" && data.view !== "scene" && !data.view.startsWith("script-")/>
      <const/showEnglish=data.view === "person"/>
      <const/showBar=data.view !== "scene" && data.view !== "unit" && !data.view.startsWith("script-")/>
      <if=showTransliteration && !showBar>
        <div class="ll-course-reading-aid">
          <Switch label="Show transliteration" on=true attrs={ "data-ll-transliteration": "" }/>
        </div>
      </if>
      <if=showBar>
        <Bar tab=data.tab nav=data.nav copy=data.copy presets=data.presets showTransliteration=showTransliteration showEnglish=showEnglish/>
      </if>
      <${VIEWS[data.view]} ...data/>
    </div>
    <div class="ll-course-pop" data-ll-pop role="tooltip" hidden>
      <strong data-ll-pop-word></strong>
      <span data-ll-pop-en></span>
      <small data-ll-pop-note></small>
    </div>
  </main>
  <html-script>
    (function () {
      try {
        var root = document.querySelector("[data-ll-course-lang]");
        var note = root && root.querySelector("[data-ll-review-note]");
        if (!note) return;
        var saved = JSON.parse(localStorage.getItem("ll:course-review-dismissed") || "{}");
        if (saved[root.getAttribute("data-ll-course-lang")]) note.hidden = true;
      } catch (e) {}
    })();
  </html-script>
  <html-script src="/js/course-client.js" defer></html-script>
</else>
